import React from 'react'
import { CustomerAddress } from 'lib/types'
import { Disabler } from 'lib/ui'
import { AddressPickerCard, AddressSelector, useCheckout } from 'lib/modules/checkout'
import { AddressGrid } from './styled'

interface Props {
  addresses: CustomerAddress[]
  onChange: (address?: CustomerAddress) => void
  value: number | undefined
  useAnotherLabel?: string
}

export const AddressPicker = ({
  value,
  onChange,
  addresses,
  useAnotherLabel
}: Props) => {
  const { shippingAddress, shippingMethod, billingAddress } = useCheckout()
  const isLoading = shippingAddress.isFetching || shippingMethod.isFetching || billingAddress.isFetching

  if (!addresses.length) {
    return null
  }

  return (
    <Disabler disabled={isLoading}>
      <AddressGrid>
        {addresses.map(address => {
          return (
            <AddressPickerCard
              key={address.id}
              address={address}
              onSelect={e => onChange(e.address)}
              isSelected={value ? (value === address.id) : false}
            />
          )
        })}

        <AddressSelector
          isSelected={value === undefined}
          onClick={() => onChange()}
        >
          {useAnotherLabel ?? 'Use another address'}
        </AddressSelector>
      </AddressGrid>
    </Disabler>
  )
}
